import React from 'react';
import LicenseCommunicationList from './licenseCommunicationList';
import RouteMenu from 'mrf/view/MenuRoute';

export default function LicenseCommunication({ match }) {
    return (
        <RouteMenu match={match} indexComponent={LicenseCommunicationList}>
        </RouteMenu>
    );
}